import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as settings from "../../lib/air-api-constant";
import { FilterService } from '../filter/filter.service';
import { StorageService } from '../storage/storage.service';
import { Observable, of } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class VesselService {
    // public getRoute(markerId: string): Observable<any> {
    //    //return this.http.get<any>(`http://localhost:8080/portal-service/api/v1/air/flight/${markerId}/current-location`);
    //     return this.http.get<any>(settings.UserEndPoint.Flight.FLIGHT_CURRENT_LOCATION);
    // }
    ETAThreshold: any;
    constructor(protected http: HttpClient, protected filterService: FilterService, protected storageService: StorageService) {
        this.ETAThreshold = this.storageService.getItem('eta_threshold');
    }
    // public getCureent(body: any): Observable<any> {
    //     return this.http.post<any>(settings.UserEndPoint.Flight.FLIGHT_CURRENT_POSITION, body);
    // }


    //#region current flight locaction in home page
    public getflightCurrentPosition(body: any): Observable<any> {
        // let queryParams = new HttpParams();
        // queryParams = queryParams.append("cargoMappingid", cargoMappingId || "default_value");

        // Only append cargoMappingId if it is defined and not null
        // if (cargoMappingId) {
        //     queryParams = queryParams.append("cargoMappingId", cargoMappingId);
        // }
        return this.http.post(settings.UserEndPoint.Flight.FLIGHT_CURRENT_POSITION, body);
    }
    //#endregion
    public getVesselRoute(shipmentId) { // This function TO BE REMOVED
        this.ETAThreshold = this.storageService.getItem('eta_threshold');
        let queryParams = new HttpParams();
        queryParams = queryParams.append("shipmentId", shipmentId)
        queryParams = queryParams.append("lateStatusMinRange", this.ETAThreshold.minLimit)
        queryParams = queryParams.append("lateStatusMaxRange", this.ETAThreshold.maxLimit)
        queryParams = queryParams.append("etaConfigType", this.ETAThreshold.etaConfigType)
        return this.http.get(settings.UserEndPoint.Vessel.VESSEL_ROUTE, { params: queryParams });
    }

    public getCoveredRoute(shipmentId) {
        this.ETAThreshold = this.storageService.getItem('eta_threshold');
        let queryParams = new HttpParams();
        queryParams = queryParams.append("shipmentId", shipmentId)
        // queryParams = queryParams.append("lateStatusMinRange", this.ETAThreshold.minLimit)
        // queryParams = queryParams.append("lateStatusMaxRange", this.ETAThreshold.maxLimit)
        // queryParams = queryParams.append("etaConfigType", this.ETAThreshold.etaConfigType)
        return this.http.get(settings.UserEndPoint.Flight.FLIGHT_COVERED_ROUTE, { params: queryParams });
    }

    public getPredictedRoute(shipmentId) {
        this.ETAThreshold = this.storageService.getItem('eta_threshold');
        let queryParams = new HttpParams();
        queryParams = queryParams.append("shipmentId", shipmentId)
        queryParams = queryParams.append("lateStatusMinRange", this.ETAThreshold.minLimit)
        queryParams = queryParams.append("lateStatusMaxRange", this.ETAThreshold.maxLimit)
        queryParams = queryParams.append("etaConfigType", this.ETAThreshold.etaConfigType)
        return this.http.get(settings.UserEndPoint.Vessel.VESSEL_PREDICTED_ROUTE, { params: queryParams });
    }
}